import { ReactNode } from 'react';
import {
	PromotionCard,
	PromotionCardProps,
} from '../../../../../ui/src/components/Cards/PromotionCards/PromotionCard';
import { StatCard } from './StatCard';
import styles from './StatsGrid.module.css';

export interface StatItemConfig {
	id: string;
	label: string;
	value: number | null;
	valueFormatter?: (v: number) => string;
	trendValue: number | null;
	trendLabel: string;
	trendDirection?: 'up' | 'down';
	icon: ReactNode;
}

export interface StatsGridProps {
	stats: StatItemConfig[];
	promotion?: PromotionCardProps;
}

export const StatsGrid = ({ stats, promotion }: StatsGridProps) => {
	if (!stats || stats.length === 0) return null;

	return (
		<div className={styles.grid}>
			{stats.map((stat) => (
				<StatCard
					key={stat.id}
					label={stat.label}
					value={stat.value}
					valueFormatter={stat.valueFormatter}
					trendValue={stat.trendValue}
					trendLabel={stat.trendLabel}
					trendDirection={stat.trendDirection}
					icon={stat.icon}
				/>
			))}
			{promotion && (
				<PromotionCard
					className={styles.promotionCard}
					title={promotion.title}
					subtitle={promotion.subtitle}
					buttonText={promotion.buttonText}
					onButtonClick={promotion.onButtonClick}
				/>
			)}
		</div>
	);
};
